module.exports = __webpack_public_path__ + "media/images/front/icon_window-7ae945fbbe186b2ff4c493e3b56d881c.png";